/**
 * Utility functions for the configurator components - confetti
 */

import { confetti } from 'tsparticles-confetti';

/**
 * Launch confetti on element
 * @param {String} query - Element to launch confetti on
 * @param {Array} angle - Angle of confetti
 * @param {Object} origin - Origin of confetti
 */
export async function launchConfetti(
  query,
  angle = [75, 125],
  spread = [50, 70],
  origin = { y: 0.5 },
) {
  const element = document.querySelector(query);
  element.confetti =
    element.confetti || (await confetti.create(element, { resize: true }));

  element.confetti({
    colors: ['#CE132F', '#3369B3', '#87C043', '#FA4616', '#AD0DA6', '#24B72A'],
    shapes: ['circle', 'square', 'triangle', 'star'],
    startVelocity: 40,
    gravity: 1,
    ticks: 100,
    angle: randomInRange(angle[0], angle[1]),
    spread: randomInRange(spread[0], spread[1]),
    count: randomInRange(100, 150),
    origin: origin,
  });
}

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}
